<template>
  <div class="customer-rule-content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>Custom Rules</span>
        <el-button
          type="primary"
          style="float: right"
          icon="el-icon-plus"
          @click="openFormDialog('create')"
          >Create Rule</el-button
        >
      </div>
      <div>
        <!-- <div style="margin-bottom: 20px">
          <el-input
            v-model="customer.uid1"
            @input="searchChange"
            placeholder="Search by Member code"
          >
            ><el-button
              type="primary"
              icon="el-icon-search"
              slot="append"
              :loading="loading"
              @click="searchCustomer"
              >Search</el-button
            ></el-input
          >
        </div> -->

        <div>
           <el-table
           border
           v-loading="tableLoading"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              label="Member Code"
              prop="memberCode">
            </el-table-column>
            <el-table-column
              label="PlusUID"
              prop="plusuid">
            </el-table-column>
            <el-table-column
            width="150"
            label="Action"
              align="center">
              
              <template slot-scope="scope">
                <el-button
                type="warning"
                  size="mini"
                  @click="openFormDialog('edit', scope.row.plusuid)"
                  >Edit</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="onDelete(scope.row.plusuid)"
                  >Delete</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 16px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[10, 30, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="recordTotal">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-card>

    <el-dialog style="min-height:300px" width="70%" :title="titleForm" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <div style="margin-bottom: 20px;" v-if="action === 'create'" v-loading="loading">
        <el-input v-model="customer.uid1" placeholder="Search by Member code"
         @keyup.native.enter="searchCustomer">
          ><el-button
            type="primary"
            icon="el-icon-search"
            slot="append"
            :loading="loading"
            @click="searchCustomer"
            >Search</el-button
          ></el-input
        >
        <el-alert
          v-if="!hasRule && customer.uid2"
          :title="`This member can create rules, Plus UID is ${customer.uid2}`"
          type="success"
          show-icon
          :closable="false"
        >
        </el-alert>
        <el-alert
          v-if="hasRule && customer.uid2"
          :title="`This member has rules exist!`"
          type="warning"
          show-icon
          :closable="false"
        >
        </el-alert>
      </div>
      <el-form
        ref="settingForm"
        :model="settingForm"
        label-width="180px"
        size="mini"
        v-if="!hasRule && customer.uid2"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span><i class="el-icon-bottom"></i> Payin</span>
              </div>
              <div>
                <el-form-item label="Mode">
                  <el-switch
                    v-model="settingForm.payin.mode"
                    active-text="Active"
                    inactive-text="Passive"
                    active-value="active"
                    inactive-value="passive"
                  ></el-switch>
                </el-form-item>
                <el-divider content-position="left">
                  <el-checkbox v-model="settingForm.payin.transactionCheck"
                    >Transaction Check</el-checkbox
                  >
                </el-divider>
                <el-form-item label="Blacklist">
                  <el-checkbox
                    v-model="settingForm.payin.Blacklist"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item label="Amount Check">
                  <el-checkbox
                    v-model="settingForm.payin.volumeCheck"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item label="Amount Criteria">
                  <el-input
                    type="number"
                    v-model="settingForm.payin.volumeCratirea"
                  ></el-input>
                </el-form-item>
                <el-divider content-position="left">
                  <el-checkbox v-model="settingForm.payin.pastTransactionCheck"
                    >Past Transaction Check</el-checkbox
                  >
                </el-divider>
                <el-form-item label="Total Amount">
                  <el-input
                    type="number"
                    v-model="settingForm.payin.totalVolumes"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Diligent Transaction">
                  <el-input
                    type="number"
                    v-model="settingForm.payin.totalTransactions"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Scope Date">
                  <el-input
                    type="number"
                    v-model="settingForm.payin.scopeDate"
                  ></el-input>
                </el-form-item>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span><i class="el-icon-top"></i> Payout</span>
              </div>
              <div>
                <el-form-item label="Mode">
                  <el-switch
                    v-model="settingForm.payout.mode"
                    active-text="Active"
                    inactive-text="Passive"
                    active-value="active"
                    inactive-value="passive"
                  ></el-switch>
                </el-form-item>
                <el-divider content-position="left">
                  <el-checkbox v-model="settingForm.payout.transactionCheck"
                    >Transaction Check</el-checkbox
                  >
                </el-divider>

                <el-form-item label="Amount Check">
                  <el-checkbox
                    v-model="settingForm.payout.volumeCheck"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item label="Amount Criteria">
                  <el-input
                    type="number"
                    v-model="settingForm.payout.volumeCratirea"
                  ></el-input>
                </el-form-item>
                <el-divider content-position="left">
                  <el-checkbox v-model="settingForm.payout.pastTransactionCheck"
                    >Past Transaction Check</el-checkbox
                  >
                </el-divider>

                <el-form-item label="Total Amount">
                  <el-input
                    type="number"
                    v-model="settingForm.payout.totalVolumes"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Diligent Transaction">
                  <el-input
                    type="number"
                    v-model="settingForm.payout.totalTransactions"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Scope Date">
                  <el-input
                    type="number"
                    v-model="settingForm.payout.scopeDate"
                  ></el-input>
                </el-form-item>
              </div>
            </el-card>
          </el-col>
          <el-col :span="24">
            <div style="margin-top: 20px" class="text-center">
              <el-button type="primary" @click="onSubmit" :loading="submitting"
                >Submit</el-button
              >
              <!-- <el-button
                      type="danger"
                      @click="onDelete"
                      :loading="deleting"
                      >Delete</el-button
                    > -->
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMainRules,
  getCustomRules,
  postSearchCustomRules,
  postCustomRules,
  putCustomRules,
  deleteCustomRules,
  getCustomRuleList
} from "@/api/firewall-rule";
export default {
  props:{
    projectUID: String,
    companyUID: String
  },
  data() {
    return {
      loading: false,
      tableLoading: false,
      submitting: false,
      deleting: false,
      enterTimeout: null,
      disabledCreateBtn: true,
      action: "",
      titleForm: "Create Custom Rules",
      dialogFormVisible: false,
      customer: {
        uid1: "",
        uid2: "",
      },
      hasRule: false,
      settingForm: {
        payin: {
          transactionCheck: true,
          volumeCheck: true,
          volumeCratirea: 500,
          pastTransactionCheck: true,
          scopeDate: 7,
          totalVolumes: 5000,
          totalTransactions: 5000,
          Blacklist: true,
          mode: "active",
        },
        payout: {
          transactionCheck: true,
          volumeCheck: true,
          volumeCratirea: 500,
          pastTransactionCheck: true,
          scopeDate: 7,
          totalVolumes: 5000,
          totalTransactions: 5000,
          mode: "active",
        },
      },
      tableData: [],
      query: {
        start: 0,
        length: this.pageSize,
        order: "DESC"
      },
      recordTotal: 0,
      pageSize: 10,
      currentPage: 1
      
    };
  },
  methods: {
    searchChange() {
      if (this.enterTimeout) clearTimeout(this.enterTimeout);
      this.enterTimeout = setTimeout(() => {
        this.searchCustomer();
      }, 800);
    },
    searchCustomer() {
      this.loading = true;
      this.hasRule = false;
      this.customer.uid2 = "";
      let uid1 = this.customer.uid1;
      postSearchCustomRules({ uid1: uid1 }).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.customer.uid1 = data.customer.uid1;
          this.customer.uid2 = data.customer.uid2;
          if (data.blacklist) {
            this.hasRule = true;
          }
        }
      });
    },
    getCustomRules(plusuid) {
      const loading = this.$loading('Loading...');
      getCustomRules(plusuid).then(({ result, data }) => {
        loading.close();
        if (result) {
          
            this.hasRule = false;
            this.customer.uid2 = data.plusuid;
            this.settingForm.payin = data.config.payin
            this.settingForm.payout = data.config.payout
            this.dialogFormVisible = true;
          
        }
      });
    },
    getCustomRuleList(){
      this.query.start = (this.currentPage * this.pageSize) - (this.pageSize + 1)
      if(this.query.start < 0) this.query.start = 0
      this.query.length = this.pageSize
      this.tableLoading = true
      getCustomRuleList(this.query, this.projectUID).then(({result, data})=>{
        this.tableLoading = false
        if(result){
          this.tableData = data.data
          this.recordTotal = data.recordsTotal
        }
      })
    },
    getMainRules() {
      this.loading = true;
      this.loadDefault = false;
      getMainRules().then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.settingForm.payin.mode = data.config.payin.mode;
          this.settingForm.payin.transactionCheck =
            data.config.payin.transactionCheck;
          this.settingForm.payin.volumeCheck = data.config.payin.volumeCheck;
          this.settingForm.payin.volumeCratirea =
            data.config.payin.volumeCratirea;
          this.settingForm.payin.pastTransactionCheck =
            data.config.payin.pastTransactionCheck;
          this.settingForm.payin.totalVolumes = data.config.payin.totalVolumes;
          this.settingForm.payin.totalTransactions =
            data.config.payin.totalTransactions;
          this.settingForm.payin.scopeDate = data.config.payin.scopeDate;
          this.settingForm.payin.Blacklist = data.config.payin.blacklist;

          this.settingForm.payout.mode = data.config.payout.mode;
          this.settingForm.payout.transactionCheck =
            data.config.payout.transactionCheck;
          this.settingForm.payout.volumeCheck = data.config.payout.volumeCheck;
          this.settingForm.payout.volumeCratirea =
            data.config.payout.volumeCratirea;
          this.settingForm.payout.pastTransactionCheck =
            data.config.payout.pastTransactionCheck;
          this.settingForm.payout.totalVolumes =
            data.config.payout.totalVolumes;
          this.settingForm.payout.totalTransactions =
            data.config.payout.totalTransactions;
          this.settingForm.payout.scopeDate = data.config.payout.scopeDate;
        }
      });
    },
    onSubmit() {
      if (this.action === "create") {
        this.createRules();
      } else if (this.action === "edit") {
        this.editRules(this.customer.uid2);
      }
    },
    getFormData() {
      const cloneData = JSON.parse(JSON.stringify(this.settingForm));
      delete cloneData.payin.blacklist;
      delete cloneData.payin.cooldownDay;
      delete cloneData.payout.cooldownDay;

      Object.keys(cloneData.payin).forEach((key) => {
        if (!isNaN(parseInt(cloneData.payin[key]))) {
          cloneData.payin[key] = parseInt(cloneData.payin[key]);
        }
      });
      Object.keys(cloneData.payout).forEach((key) => {
        if (!isNaN(parseInt(cloneData.payout[key]))) {
          cloneData.payout[key] = parseInt(cloneData.payout[key]);
        }
      });

      return cloneData;
    },
    openFormDialog(action, plusuid = '') {
      this.action = action;
      this.customer.uid1 = ""
      this.customer.uid2 = ""
      this.hasRule = false
      if (this.action === "edit") {
        this.titleForm = "Edit Custom Rules";
        this.getCustomRules(plusuid);
        
      } else {
        this.titleForm = "Create Custom Rules";
        this.dialogFormVisible = true;
      }
      
    },
    createRules() {
      this.submitting = true;
      postCustomRules(this.customer.uid2, this.getFormData()).then(
        ({ result, data }) => {
          this.submitting = false;
          if (result) {
            this.$message.success("Success");
            this.dialogFormVisible = false;
            this.getCustomRuleList();
          } else {
            this.$message.error(data.message);
          }
        }
      );
    },
    editRules(plusuid) {
      this.submitting = true;
      putCustomRules(plusuid, this.getFormData()).then(
        ({ result, data }) => {
          this.submitting = false;
          if (result) {
            this.$message.success("Success");
            this.dialogFormVisible = false;
            this.getCustomRuleList();
          } else {
            this.$message.error(data.message);
          }
        }
      );
    },
    onDelete(plusuid) {
      this.$confirm("Are you sure to delete this rule?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        this.deleting = true;
        deleteCustomRules(plusuid).then(({ result, data }) => {
          this.deleting = false;
          if (result) {
            this.$message.success("Success");
            this.getCustomRuleList();
          } else {
            this.$message.error(data.message);
          }
        });
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getCustomRuleList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getCustomRuleList()
      
    }
  },
  mounted(){
    this.getCustomRuleList();
  }
};
</script>

<style lang="scss">
.customer-rule-content {
  padding: 0;

  .el-tag {
    text-transform: capitalize;
  }
}
</style>